import { Split } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgSplit = mkIcon(Split);